import React from "react";
import { useState } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link, Outlet } from "react-router-dom";
import Footer from "../components/Partials/Footer";
import Header from "../components/Partials/Header";
import auth from "../init.firebase";
import "./AccountLayout.scss";
import avatar from "../../src/assets/avatar.png";
import { useEffect } from "react";
import { useGetLoggedInUserInfoByEmailQuery } from "../redux/account/accountApi";

const AccountLayout = ({ setShow }) => {
  const [selectClass, setSelectClass] = useState();
  const [user] = useAuthState(auth);
  const [haveUser, setHaveUser] = useState(true);

  const { data: accountData, isLoading } = useGetLoggedInUserInfoByEmailQuery(
    user?.email,
    { skip: haveUser }
  );

  useEffect(() => {
    if (user?.email) {
      setHaveUser(false);
    }
  }, [user?.email]);

  return (
    <>
      <Header setShow={setShow} />
      <Container className="my-5">
        <Row className="mt-4">
          <Col md={3} className="border-end">
            <div className="text-center">
              <div>
                <img
                  src={
                    accountData?.data.photoUrl
                      ? accountData?.data?.photoUrl
                      : user?.photoURL
                      ? `${user?.photoURL}`
                      : avatar
                  }
                  className="rounded-circle mb-2"
                  style={{
                    width: "160px",
                    height: "160px",
                    objectFit: "cover",
                  }}
                  fluid
                />
              </div>
              <p
                className="text-center rounded-pill  d-inline p-1 fw-bold"
                style={{ background: "#ccc", fontSize: "12px" }}
              >
                {accountData?.data?.groupName}
              </p>
              <h4 className=" mb-0">{accountData?.data?.name}</h4>
              <p className="text-break">{user?.email}</p>
            </div>

            <div className="doted-container mt-3 mb-2"></div>

            <div className="mt-1">
              <div>
                <Link
                  style={{ display: "block" }}
                  onClick={() => setSelectClass("account")}
                  to="/account"
                  className={`text-decoration-none w-100 text-dark px-2 mb-2 ${
                    selectClass === "account" && "selected_class"
                  }`}
                >
                  My Account
                </Link>
              </div>
              {/* <div className="mt-2">
								<Link
									to="/account/addresses"
									className="text-decoration-none text-dark"
								>
									View Addresses
								</Link>
							</div> */}
              <div className="mt-2">
                <Link
                  style={{ display: "block" }}
                  to="/account/orders"
                  onClick={() => setSelectClass("orders")}
                  className={`text-decoration-none w-100 text-dark px-2 mb-2 ${
                    selectClass === "orders" && "selected_class"
                  }`}
                >
                  View Orders
                </Link>
              </div>
              <div className="mt-2">
                <Link
                  style={{ display: "block" }}
                  to="/account/reviews"
                  onClick={() => setSelectClass("reviews")}
                  className={`text-decoration-none w-100 text-dark px-2  ${
                    selectClass === "reviews" && "selected_class"
                  }`}
                >
                  View Reviews
                </Link>
              </div>
              {/* <div className="mt-2">
								<Link
									to="/account/wishlist"
									className="text-decoration-none text-dark"
								>
									My Wishlist
								</Link>
							</div> */}
            </div>
          </Col>
          <Col md={9}>
            <Container>
              <Outlet />
            </Container>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default AccountLayout;
